import { useNomenclatureItems } from '@/features/common/useNomenclatureItems';
import type { DomainItem } from '@/features/common/types/DomainItem';

/** The nomenclature code seeded by V036. Renaming it here without renaming the seed empties every picker. */
export const LIBRARY_DOMAINS = 'LIBRARY_DOMENII';

/**
 * The library's thematic domains (FR-021, ToR §6.6 and §6.12).
 *
 * The fetch itself now lives in `features/common/useNomenclatureItems`, so a module reading a
 * different nomenclature — the advisory providers' specialization domains, say — asks for its own
 * code instead of copying this body or borrowing a hook named after the library's vocabulary.
 */
export function useThematicDomains(): DomainItem[] {
  return useNomenclatureItems(LIBRARY_DOMAINS);
}

/**
 * The label to show, falling back to Romanian — the tender requires RO everywhere, EN only in
 * places.
 *
 * Typed by the two fields it reads rather than by DomainItem, so every nomenclature item that
 * carries a translated name can be named through one function: the same
 * `/nomenclatures/{id}/items` payload backs the library's domains, the training topics, the
 * content categories and the providers' specialization domains, and each of them was picking
 * `nameRo` on its own.
 */
export function domainLabel(
  item: { nameRo: string; nameEn: string | null },
  language: string,
): string {
  return language === 'en' && item.nameEn ? item.nameEn : item.nameRo;
}
